import { render, staticRenderFns } from "./RedirectBot.vue?vue&type=template&id=9fc983d8&scoped=true&"
import script from "./RedirectBot.vue?vue&type=script&lang=js&"
export * from "./RedirectBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc983d8",
  null
  
)

export default component.exports